module.exports = __webpack_public_path__ + "img/landscape_8.7576742e.jpg";